import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var XsnShortcutSvg = function XsnShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.147 6.5 17 2.353V6.25c0 .137.113.25.25.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.5 10.204A9 9 0 0 1 11 18a8.96 8.96 0 0 1-.935 4H21.25a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C3A9D4",
    d: "M11 10.5h7.75a.25.25 0 1 0 0-.5H11zM11 14h7.75a.25.25 0 1 0 0-.5H11zM11 17.5h7.75a.25.25 0 1 0 0-.5H11z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C8C6C4",
    fillRule: "evenodd",
    d: "M19.25 8.75h-11v2.774q.115.111.226.226H19.25a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1m-8.678 6.5h8.678a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H8.924q.395.475.722 1h9.604v1h-9.066q.223.485.388 1m.397 3.5h8.281a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-8.533q.125.49.197 1h8.336v1h-8.253a9 9 0 0 1-.028 1m-1.719-8v-1h10v1z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#605E5C",
    fillRule: "evenodd",
    d: "m17.073 1.72 4.707 4.707c.142.142.22.33.22.53V21.75a.75.75 0 0 1-.75.75H9.796q.142-.245.269-.5H21.25a.25.25 0 0 0 .25-.25V7h-4.25a.75.75 0 0 1-.75-.75V2H6.75a.25.25 0 0 0-.25.25v7.954a9 9 0 0 0-.5-.268V2.25a.75.75 0 0 1 .75-.75h9.793c.199 0 .39.08.53.22m4.073 4.78L17 2.354V6.25a.25.25 0 0 0 .25.25z",
    clipRule: "evenodd",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A3889",
    fillRule: "evenodd",
    d: "M2 9v-.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1h-1.014q.015-.248.014-.5a9 9 0 0 0-9-9",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M8.25 11.524V10h-1.5v.354c.541.337 1.044.73 1.5 1.17",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  }));
};
export var XsnShortcut = function XsnShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: XsnShortcutSvg
  }));
};